import { Chip, styled, useTheme } from "@mui/material";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { isPropValid } from "Infrastructure/Utils/StyleUtils";

type ActorCollaborationChipProps = {
  isOpenToCollaboration: boolean;
};

const StyledChip = styled(Chip, { shouldForwardProp: isPropValid })<{
  $backgroundColor: string;
  $textColor: string;
}>`
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
  font-size: 12px;
  font-weight: 400;

  .MuiChip-label {
    padding: ${(props) => props.theme.spacing(0, Spacing.M)};
  }
`;

export const ActorCollaborationChip = ({
  isOpenToCollaboration,
}: ActorCollaborationChipProps): React.ReactNode => {
  const { t } = useResource();
  const theme = useTheme();

  return (
    <StyledChip
      label={
        isOpenToCollaboration
          ? t(Resources.Actors.ActorDetail.OpenToCollaboration)
          : t(Resources.Actors.ActorDetail.NotOpenToCollaboration)
      }
      $backgroundColor={
        isOpenToCollaboration
          ? theme.palette.info.dark
          : theme.palette.error.dark
      }
      $textColor={theme.palette.text.primary}
    />
  );
};
